module.exports = {
      id: "next-story-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#next-story",
      toString: function () {
        return this.url;
      }
    }